import * as React from 'react';
import { Typography } from '../../../atoms';
import clsx from 'clsx';
import useStyles from './Day.styles';

export interface IDayProps {
  day: number;
  selected?: boolean;
  disabled?: boolean;
  gridColumn?: number;
  onClick?(): unknown;
}

const Day = React.forwardRef<HTMLButtonElement, IDayProps>(
  ({ selected, onClick, day, disabled, gridColumn }, ref) => {
    const classes = useStyles();

    return (
      <button
        type="button"
        className={clsx(classes.root, {
          [classes.selected]: selected,
          [classes.disabled]: disabled,
        })}
        onClick={onClick}
        disabled={disabled}
        ref={ref}
        style={{ gridColumn }}
      >
        <Typography as={'span'} variant={'body01'}>
          {day}
        </Typography>
      </button>
    );
  },
);

Day.displayName = 'Day';
export default Day;
